import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, map, switchMap, tap} from 'rxjs/operators';
import {AsaxElasticService} from 'asax-elastic';
import {DropdownSkyObjectItem} from "./sky-objects-input/search-input-sky-objects.component";

const objectTypeCountersIndex = 'object-type-counters';

@Injectable({
  providedIn: 'root'
})
export class SkyObjectsService {

  constructor(private readonly asaxElasticService: AsaxElasticService) {
  }

  fetchSkyObjects(): Observable<DropdownSkyObjectItem[]> {
    return this.asaxElasticService.countByQuery(
      {index: objectTypeCountersIndex}
    ).pipe(
      switchMap(({count}) => this.asaxElasticService.searchByQuery({
        index: objectTypeCountersIndex,
        body: {
          _source: ['counter', 'longtype', 'resolverType'],
          size: count
        }
      })),
      map(({hits}) => hits?.hits.map(({_source}) => ({
        value: _source.longtype,
        text: `${_source.longtype} (${_source.counter})`,
        resolverType: _source.resolverType
      }))),
      tap(skyObjects => skyObjects.sort(((a, b) => a.text.localeCompare(b.text)))),
      catchError(() => [])
    );
  }
}
